(function () {
  'use strict';

  var VERSION = '2026-08-06-cart-attribution-v2';
  var storagePrefix = 'vpl_attr_';
  var cartSyncKey = storagePrefix + 'cart_sync_signature';
  var trackingTag = 'gclid-present';
  var adKeys = [
    'gclid',
    'gbraid',
    'wbraid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gad_source',
    'campaignid',
    'adgroupid',
    'creative',
    'device',
    'network',
    'msclkid'
  ];

  window.VPL_SHOPIFY_CART_ATTRIBUTION_VERSION = VERSION;

  function readStorage(key) {
    try { return window.localStorage.getItem(storagePrefix + key) || ''; } catch (e) { return ''; }
  }

  function writeStorage(key, value) {
    if (!value) return;
    try { window.localStorage.setItem(storagePrefix + key, String(value)); } catch (e) {}
  }

  function captureUrlParams() {
    var params = new URLSearchParams(window.location.search);
    adKeys.forEach(function (key) { writeStorage(key, params.get(key)); });
    if (!readStorage('landing_page')) writeStorage('landing_page', window.location.href);
    writeStorage('last_seen_page', window.location.href);
  }

  function attr(name, value) {
    var out = {};
    if (value) out['_vpl_' + name] = value;
    return out;
  }

  function attributionAttributes() {
    var out = {};
    adKeys.concat(['landing_page', 'last_seen_page']).forEach(function (key) {
      Object.assign(out, attr(key, readStorage(key)));
    });
    if (readStorage('gclid')) {
      out._vpl_tracking_tag = trackingTag;
      out._vpl_gclid_present = 'true';
    }
    out._vpl_capture_version = VERSION;
    out._vpl_capture_updated_at = new Date().toISOString();
    return out;
  }

  function meaningfulAttributes(attributes) {
    return Object.keys(attributes).some(function (key) {
      return key !== '_vpl_capture_version' && key !== '_vpl_capture_updated_at' && attributes[key];
    });
  }

  function signature(attributes) {
    return JSON.stringify(Object.keys(attributes).sort().map(function (key) {
      if (key === '_vpl_capture_updated_at') return [key, ''];
      return [key, attributes[key]];
    }));
  }

  function syncCartAttributes() {
    captureUrlParams();
    var attributes = attributionAttributes();
    if (!meaningfulAttributes(attributes)) return;
    var sig = signature(attributes);
    try {
      if (window.sessionStorage.getItem(cartSyncKey) === sig) return;
      window.sessionStorage.setItem(cartSyncKey, sig);
    } catch (e) {}
    if (!window.fetch) return;
    window.fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {});
  }

  captureUrlParams();
  syncCartAttributes();
  [500, 1500, 5000].forEach(function (delay) {
    window.setTimeout(syncCartAttributes, delay);
  });
  ['click', 'submit', 'change'].forEach(function (eventName) {
    document.addEventListener(eventName, syncCartAttributes, true);
  });
})();
